import { connect } from "react-redux";
import { togglePopup } from "../../redux/actions/global/global.actions";
import ModesModal from "./ModesModal";

const mapState = ({ users }) => ({
  myData: users.myData,
});
const mapDispatchToProps = (dispatch) => ({
  togglePopup: (data) => dispatch(togglePopup(data)),
});
export default connect(mapState, mapDispatchToProps)(ModesModal);
